export function distanceKm(a, b) {
    if (!a || !b || typeof a.lat !== 'number' || typeof a.lng !== 'number' || typeof b.lat !== 'number' || typeof b.lng !== 'number') {
        return null;
    }
    const R = 6371;
    const toRad = d => (d * Math.PI) / 180;
    const dLat = toRad(b.lat - a.lat);
    const dLng = toRad(b.lng - a.lng);
    const lat1 = toRad(a.lat);
    const lat2 = toRad(b.lat);
    const x = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
    return Math.round((2 * R * Math.asin(Math.sqrt(x))) * 10) / 10;
}


export function etaMinutes(distanceKmValue, speedKmh = 45) {
    if (typeof distanceKmValue !== 'number' || !isFinite(distanceKmValue) || distanceKmValue < 0) return null;
    return Math.round((distanceKmValue / speedKmh) * 60);
}


